import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const AccountInvitesApi = {
    get: (options?: BaseApiQueryOptions) => apiQueryOptions(['accountInvites', 'get'], (api) => api.accountInvites.get(), options),
    invite: (options?: BaseApiMutationOptions<ApiClient['accountInvites']['invite']>) => apiMutationOptions((api) => api.accountInvites.invite, options),
    remove: (options?: BaseApiMutationOptions<ApiClient['accountInvites']['remove']>) => apiMutationOptions((api) => api.accountInvites.remove, options),
    reset: (options?: BaseApiMutationOptions<ApiClient['accountInvites']['reset']>) => apiMutationOptions((api) => api.accountInvites.reset, options)
};
